import { Button, Modal } from "antd";
import React, { useState } from "react";
import PageForm from "./PageForm";
import { IoMdClose } from "react-icons/io";

// Define the types for the props
interface PageModalProps {
  modalOpen: boolean;
  handleClose: () => void;
  // handle_submit: (e: React.FormEvent) => void; // Updated type
  actionType: String;
  id?: string;
  actionItem?: any; // Replace `any` with a more specific type if available
  setExpandedRowKey?: (key: string | null) => void;
  linkType?: string;
}

const PageModal: React.FC<PageModalProps> = (props) => {
  const {
    modalOpen,
    handleClose,
    // handle_submit,
    actionType,
    id,
    actionItem,
    setExpandedRowKey,
    linkType,
  } = props;

  const [loading, setSubmitLoading] = useState<boolean>(false);

  return (
    <Modal
      title={
        actionType === "add_page"
          ? "Add Page"
          : actionType === "edit_page"
          ? "Edit Page"
          : actionType === "add_ui_component"
          ? "Add Page Component"
          : "Edit Page Component"
      }
      open={modalOpen}
      onCancel={handleClose}
      footer={
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            key="confirm"
            type="primary"
            htmlType="submit"
            form="page_form"
            // onClick={handle_submit}
            loading={loading}
          >
            {actionType === "add_page"
              ? "Add"
              : actionType === "edit_page"
              ? "Update"
              : actionType === "add_ui_component"
              ? "Add"
              : "Update"}
          </Button>
        </>
      }
    >
      <PageForm
        close={handleClose}
        actionType={actionType || ""}
        getId={id || ""}
        actionItem={actionItem}
        setLoading={setSubmitLoading}
        setExpandedRowKey={setExpandedRowKey}
        linkType={linkType || null}
        // set_expanded_row_key={}
      />
    </Modal>
  );
};

export default PageModal;
